import React from "react";
import styled from "@emotion/styled";
import { Link } from "@reach/router";

import { useTheme } from "../../contexts/themeContext";
import features from "../../utils/featuresData";

function OurFeatures() {
  const theme = useTheme();

  return (
    <>
      <DiscoverStyled
        borderColor={theme.secondDark}
        animateColor={theme.mainViolet}
        linkColor={theme.secondDark}
      >
        <Link to="products">
          Descoperiti-ne <i className="fas fa-arrow-circle-right" />
        </Link>
      </DiscoverStyled>
      <Layout borderColor={theme.secondDark}>
        {features.map((f, i) => (
          <Feature key={i} feature={f} />
        ))}
      </Layout>
    </>
  );
}

const Feature = ({ feature }) => {
  const theme = useTheme();

  return (
    <FeatureStyled
      iBorder={theme.secondViolet}
      iColor={theme.secondDark}
      pColor={theme.mainDark}
    >
      <div>
        <i className={feature.icon} />
      </div>
      <p>{feature.text}</p>
    </FeatureStyled>
  );
};

const DiscoverStyled = styled.div`
  width: 100%;
  padding-top: 50px;
  border-top: 3px solid ${props => props.borderColor};
  display: flex;
  justify-content: center;
  margin-bottom: 25px;

  @media (max-width: 500px) {
    margin-bottom: 0px;
  }

  a {
    position: relative;
    text-decoration: none;
    font-size: 24px;
    padding-bottom: 5px;
    font-weight: 600;
  }

  a {
    color: ${props => props.linkColor};
  } /* Unvisited link  */
  a:visited {
    color: ${props => props.linkColor};
  } /* Visited link    */
  a:hover {
    color: #${props => props.linkColor};
  } /* Mouse over link */
  a:active {
    color: ${props => props.linkColor};
  } /* Selected link   */

  a::before {
    content: "";
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    height: 4px;
    background-color: ${props => props.animateColor};
    transform-origin: bottom right;
    transform: scaleX(0);
    transition: transform 0.5s ease;
  }

  a:hover::before {
    transform-origin: bottom left;
    transform: scaleX(1);
  }
`;

const Layout = styled.section`
  padding: 10px;
  padding-top: 50px;

  display: flex;
  flex-wrap: wrap;
  justify-content: center;
`;

const FeatureStyled = styled.div`
  width: 40%;
  display: flex;
  align-items: center;
  margin-bottom: 50px;

  @media (max-width: 500px) {
    width: 100%;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }

  div {
    border: 2px solid ${props => props.iBorder};
    padding: 15px;
    transform: rotate(45deg);
    margin-right: 50px;
    border-radius: 5px;

    @media (max-width: 500px) {
      margin-right: 0px;
    }

    i {
      font-size: 20px;
      transform: rotate(-45deg);
      color: ${props => props.iColor};
    }
  }

  p {
    color: ${props => props.pColor};
    font-family: "Helvetica Neue", sans-serif;
    font-size: 15px;
    line-height: 24px;
    margin: 0 0 24px;
    text-align: justify;
    text-justify: inter-word;

    @media (max-width: 500px) {
      text-align: center;
      margin-top: 30px;
      margin-bottom: 0px;
    }
  }
`;

export default OurFeatures;
